import React, { useRef, useState } from "react";
import { Eye, EyeOff, KeyRound } from "lucide-react";
import api, { formatApiError } from "@/lib/api";
import { useAuth } from "@/lib/auth";
import "@/pages/Operations.css";

export default function PasswordForm({ target = null, onDone }) {
  const { logout } = useAuth();
  const [values, setValues] = useState({ current: "", password: "", confirm: "" });
  const [visible, setVisible] = useState(false), [busy, setBusy] = useState(false), [error, setError] = useState("");
  const pending = useRef(false);
  async function submit(e) {
    e.preventDefault();
    if (pending.current) return;
    setError("");
    if (values.password !== values.confirm) { setError("Yeni şifreler eşleşmiyor."); return; }
    pending.current = true; setBusy(true);
    try {
      if (target) await api.put(`/company/users/${target.id}`, { password: values.password });
      else await api.post("/auth/password", { current_password: values.current, new_password: values.password });
      setValues({ current: "", password: "", confirm: "" });
      if (target) onDone?.(); else await logout();
    } catch (err) { setError(formatApiError(err)); }
    finally { pending.current = false; setBusy(false); }
  }
  return <section className="operations border-y border-slate-200 py-5" aria-label={target ? "Kullanıcı şifresini değiştir" : "Şifremi değiştir"}>
    <h2 className="text-lg font-semibold">{target ? `${target.name} · Şifre değiştir` : "Şifremi değiştir"}</h2>
    <p className="text-sm text-slate-500">Şifre değiştiğinde {target ? "bu hesabın tüm oturumları" : "tüm oturumlarınız"} geçersiz kılınır.</p>
    <form onSubmit={submit} className="space-y-4 max-w-lg">
      <fieldset disabled={busy} className="space-y-4">
        {!target && <label className="block text-sm">Mevcut şifre<input className="input mt-1" type="password" autoComplete="current-password" required value={values.current} onChange={e => setValues(v => ({ ...v, current: e.target.value }))} /></label>}
        {[['password', 'Yeni şifre'], ['confirm', 'Yeni şifre tekrar']].map(([key, label]) => <label className="block text-sm" key={key}>{label}<input className="input mt-1" type={visible ? "text" : "password"} autoComplete="new-password" minLength={8} maxLength={72} required value={values[key]} onChange={e => setValues(v => ({ ...v, [key]: e.target.value }))} /></label>)}
        <div className="flex flex-wrap gap-2 items-center">
          <button type="button" className="btn-secondary" onClick={() => setVisible(v => !v)} title={visible ? "Yeni şifreleri gizle" : "Yeni şifreleri göster"} aria-label={visible ? "Yeni şifreleri gizle" : "Yeni şifreleri göster"}>{visible ? <EyeOff size={18} /> : <Eye size={18} />}</button>
          <button className="btn-primary"><KeyRound size={16} />{busy ? "Kaydediliyor…" : "Şifreyi değiştir"}</button>
          {target && <button type="button" className="btn-secondary" onClick={() => onDone?.(false)}>Vazgeç</button>}
        </div>
      </fieldset>
      {error && <p className="text-sm text-red-700" role="alert">{error}</p>}
    </form>
  </section>;
}
